import Link from "next/link"

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Roomvia Brand */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-teal-600">Roomvia</h3>
            <p className="text-sm text-gray-600">Transform your space with AI-powered interior design</p>
          </div>

          {/* Product */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Product</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/gallery" className="text-sm text-gray-600 hover:text-gray-900">
                  Gallery
                </Link>
              </li>
              <li>
                <Link href="/designer" className="text-sm text-gray-600 hover:text-gray-900">
                  Designer
                </Link>
              </li>
              <li>
                <Link href="/pricing" className="text-sm text-gray-600 hover:text-gray-900">
                  Pricing & Credits
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/about" className="text-sm text-gray-600 hover:text-gray-900">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/support" className="text-sm text-gray-600 hover:text-gray-900">
                  Support / FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/legal/privacy" className="text-sm text-gray-600 hover:text-gray-900">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/legal/terms" className="text-sm text-gray-600 hover:text-gray-900">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href="/legal/ai-disclaimer" className="text-sm text-gray-600 hover:text-gray-900">
                  AI Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-center text-sm text-gray-500">
            © 2026 Roomvia. All rights reserved.
            {process.env.NEXT_PUBLIC_BUILD_NUMBER && ` | ${process.env.NEXT_PUBLIC_BUILD_NUMBER}`}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
